<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P245F0001">
  <div class="form-row mt-3">
    <div class="form-field">
      <input pInputText type="text" formControlName="clave_Pais" class="form-control" [placeholder]="'Ingrese clave país'" appPermissionControl="P245K0001">
      <label>Clave País</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="descripcion" class="form-control"
        [placeholder]="'Ingrese descripción'" appPermissionControl="P245K0002">
      <label>Descripción</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown
        formControlName="moneda"
        [options]="monedas"
        optionLabel="descripcion"
        optionValue="moneda"
        [showClear]="true"
        placeholder="Seleccione una moneda"
        [filter]="true"
        appendTo="body"
        class="w-100"
       appPermissionControl="P245K0003">
        <ng-template let-moneda pTemplate="item">
          <div>{{ moneda.moneda }} | {{ moneda.descripcion }}</div>
        </ng-template>
      </p-dropdown>
      <label>Clave Moneda</label>
    </div>
  </div>

  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
      [disabled]="!form.valid || loading" appPermissionControl="P245B0001">
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P245B0002">
      <mat-icon>tune</mat-icon>
      Customizables
    </button>
  </div>
</form>

<style>
  :host ::ng-deep .form-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }

  :host ::ng-deep .form-field {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
    position: relative;
  }

  :host ::ng-deep .form-control {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  :host ::ng-deep .form-control:disabled {
    background: #e0e0e0 !important;
    color: #555 !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
  }

  :host ::ng-deep .form-field label {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }

  :host ::ng-deep .button-section {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }

  :host ::ng-deep .p-error {
    color: #f44336;
    font-size: 0.75rem;
  }
</style> 